module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div class=\"<%= (model.additionalClasses || []).join(' '); %>\">\n<div class=\"texts\">\n<div class=\"title trigger\">\n<h2><%- model.title || '' %></h2>\n<%\nif(config.collapsable){\n%>\n<div class=\"toggle\">\n<div class=\"minus visibleWhenOpened\"></div>\n<div class=\"plus visibleWhenClosed\"></div>\n</div>\n<%\n}\n%>\n</div>\n<div class=\"text\">\n<%- model.text %>\n</div>\n</div>\n</div>"
  , __filename = "components/templates/standard/html/html.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"")
    ; __append(escapeFn( (model.additionalClasses || []).join(' ') ))
    ; __append("\">\n<div class=\"texts\">\n<div class=\"title trigger\">\n<h2>")
    ; __line = 4
    ; __append( model.title || '' )
    ; __append("</h2>\n")
    ; __line = 5
    ; 
if(config.collapsable){

    ; __line = 7
    ; __append("\n<div class=\"toggle\">\n<div class=\"minus visibleWhenOpened\"></div>\n<div class=\"plus visibleWhenClosed\"></div>\n</div>\n")
    ; __line = 12
    ; 
}

    ; __line = 14
    ; __append("\n</div>\n<div class=\"text\">\n")
    ; __line = 17
    ; __append( model.text )
    ; __append("\n</div>\n</div>\n</div>")
    ; __line = 20
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/standard/html/html.ejs

}